import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './styles/studentFamilyForm.css';
import './styles/personManagementHeroTitles.css';
import './styles/documentWorkspaceTypography.css';
import './features/studentSettingsEnhancements/bootstrap';
import './features/humanResourcesEnhancements';
import App from './App';
import './styles/moduleResponsive.css';
import reportWebVitals from './reportWebVitals';
import { installProcessDraftStorageGuard } from './utils/processDraftStorageGuard';

// ProcessRunner used to persist the entire request when the assignment changed.
// Install the guard before React mounts so old oversized drafts are removed
// before the first request form attempts to read and parse them.
installProcessDraftStorageGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();